<template>
  <footer>
    <div class="footer">
      <div class="row no-gutters">
        <div class="col-6">
          <div class="footer__partner">PARTNER AKCJI</div>
          <a href="http://gazeta.pl" target="_blank" rel="nofollow">
            <img src="../assets/images/logo_gazeta-pl.png" />
          </a>
        </div>
        <div class="col-6">
          <div>
            <router-link class="footer__link" to="/kontakt"
              >Kontakt</router-link
            >
          </div>
          <div>
            <router-link class="footer__link" to="/regulamin"
              >Regulamin</router-link
            >
          </div>
          <div>
            <router-link class="footer__link" to="/pytania-i-odpowiedzi"
              >Pytania i Odpowiedzi</router-link
            >
          </div>
          <div>
            <router-link class="footer__link" to="/prywatnosc">
              Polityka prywatności</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <a href="http://greenpeace.pl" target="_blank">
        <img src="../assets/images/logo_greenpeace.png" />
      </a>
      <div>&#169; {{ currentYear }} by Fundacja Greenpeace</div>
    </div>
    <div class="footer__grass">
      <div class="footer__bees">
        <img
          class="footer__bee--first"
          src="../assets/images/bee-single.svg"
          alt="Pszczółka"
        />
        <img
          class="footer__bee--second"
          src="../assets/images/bees/bee__8.svg"
          alt="Pszczółka"
        />
        <img
          class="footer__bee--three"
          src="../assets/images/bees/bee__2.svg"
          alt="Pszczółka"
        />
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      title: "footer",
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>
